import { render, staticRenderFns } from "./ApplyCategory.vue?vue&type=template&id=6d00fa28&scoped=true"
import script from "./ApplyCategory.vue?vue&type=script&lang=js"
export * from "./ApplyCategory.vue?vue&type=script&lang=js"
import style0 from "./ApplyCategory.vue?vue&type=style&index=0&id=6d00fa28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d00fa28",
  null
  
)

export default component.exports